import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export interface UnlockConnectorCommand {
  evseId: number;
  connectorId: number;
}

const client = createClient('/rest/operator-api/charging-stations');

export const unlockConnector: SaveOperation<UnlockConnectorCommand, void, string> = postRequestFactory<
  UnlockConnectorCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/unlock-connector',
  permissionId: commandPermissions.UNLOCK_CONNECTOR
});
